import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedMaterialModule } from "@app/view/shared/shared-material.module";
import { StompStatusComponent } from "@app/view/shared/widgets/stomp-status/stomp-status.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";
import { ChildEntityManagerComponent } from "@app/view/shared/child-entity-manager/child-entity-manager.component";
import { BaseSingleEntityPageComponent } from "@app/view/shared/base-pages/base-single-entity-page/base-single-entity-page.component";
import { ChildEntityAddListDialogComponent } from "@app/view/shared/child-entity-add-list-dialog/child-entity-add-list-dialog.component";
import { MomentModule } from "ngx-moment";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PropertyValuePipe } from "./pipes/property-value.pipe";
import { ServerStatusDialogComponent } from "@app/view/shared/server-status-dialog/server-status-dialog.component";
import { NgxJsonViewerModule } from "ngx-json-viewer";
import { ServiceErrorPopupComponent } from "./service-error-popup/service-error-popup.component";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { DateNavigatorComponent } from "./date-navigator/date-navigator.component";
import { AlertToolComponent } from "./alerts/alert-tool/alert-tool.component";
import { ChildEntityDetailDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-detail-display";
import {
  ChildEntityDisplayDirective,
  ChildEntityDisplayResolverComponent
} from "./child-entity-display-resolver/child-entity-display-resolver.component";
import { ChildEntitySkillRuleDisplayComponent } from "./child-entity-skill-rule-display/child-entity-skill-rule-display.component";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { BaseTimeNavigablePageComponent } from "./base-pages/base-time-navigable-page/base-time-navigable-page.component";
import { SafePipe } from "./pipes/safe.pipe";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { ColorPickerDirective } from "ngx-color-picker";
import { ColorChooserComponent } from "./color-chooser/color-chooser.component";
import { ReservationAlertToolComponent } from "./alerts/reservation-alert-tool/reservation-alert-tool.component";
import { FollowOnToolComponent } from "./alerts/follow-on-tool/follow-on-tool.component";
import { VisitTypeChooserDialogComponent } from "./visit-type-chooser-dialog/visit-type-chooser-dialog.component";
import { AngularSplitModule } from "angular-split";
import { CalendarDateDisplayComponent } from "./calendar-date-display/calendar-date-display.component";
import { FileDownloadDirective } from "./directives/file-download.directive";
import { TicketAuditViewerComponent } from "./audits/ticket-audit-viewer/ticket-audit-viewer.component";
import { TicketAuditRendererComponent } from "./audits/ticket-audit-renderer/ticket-audit-renderer.component";
import { AuditJumpButtonComponent } from "./audits/audit-jump-button/audit-jump-button.component";
import { ResourceAvailabilityAuditViewerComponent } from "./audits/resource-availability-audit-viewer/resource-availability-audit-viewer.component";
import { ResourceAvailabilityAuditRendererComponent } from "./audits/resource-availability-audit-renderer/resource-availability-audit-renderer.component";
import { VisitAuditViewerComponent } from "./audits/visit-audit-viewer/visit-audit-viewer.component";
import { VisitAuditRendererComponent } from "./audits/visit-audit-renderer/visit-audit-renderer.component";
import { TimesheetCodeChooserComponent } from "./timesheet-code-chooser/timesheet-code-chooser.component";
import { LocationChooserComponent } from "@app/view/shared/location-chooser/location-chooser.component";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { PriorityChooserComponent } from "./priority-chooser/priority-chooser.component";
import { DialogHeaderComponent } from "./dialog-header/dialog-header.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    ColorPickerDirective,
    DragDropModule,
    NgxUiLoaderModule.forRoot({}),
    NgxJsonViewerModule,
    AngularSplitModule,
    StompStatusComponent,
    BaseSingleEntityPageComponent,
    ChildEntityDisplayComponent,
    ChildEntityDetailDisplayComponent,
    ChildEntityManagerComponent,
    ChildEntityAddListDialogComponent,
    PropertyValuePipe,
    ServerStatusDialogComponent,
    ServiceErrorPopupComponent,
    DateNavigatorComponent,
    AlertToolComponent,
    ChildEntityDisplayResolverComponent,
    ChildEntityDisplayDirective,
    ChildEntitySkillRuleDisplayComponent,
    BaseTimeNavigablePageComponent,
    SafePipe,
    GridComponent,
    ColorChooserComponent,
    ReservationAlertToolComponent,
    FollowOnToolComponent,
    VisitTypeChooserDialogComponent,
    CalendarDateDisplayComponent,
    FileDownloadDirective,
    TicketAuditViewerComponent,
    TicketAuditRendererComponent,
    AuditJumpButtonComponent,
    ResourceAvailabilityAuditViewerComponent,
    ResourceAvailabilityAuditRendererComponent,
    VisitAuditViewerComponent,
    VisitAuditRendererComponent,
    TimesheetCodeChooserComponent,
    LocationChooserComponent,
    ConfirmDialogComponent,
    PriorityChooserComponent,
    DialogHeaderComponent
  ],
  providers: [ServiceErrorHandlerService],
  exports: [
    CommonModule,
    TranslateModule,
    SharedMaterialModule,
    BaseSingleEntityPageComponent,
    ColorPickerDirective,
    FormsModule,
    ReactiveFormsModule,
    StompStatusComponent,
    ChildEntityDisplayComponent,
    ChildEntityDetailDisplayComponent,
    ChildEntityManagerComponent,
    ChildEntityAddListDialogComponent,
    MomentModule,
    GridComponent,
    NgxJsonViewerModule,
    DragDropModule,
    PropertyValuePipe,
    ServerStatusDialogComponent,
    DateNavigatorComponent,
    AlertToolComponent,
    NgxUiLoaderModule,
    SafePipe,
    ReservationAlertToolComponent,
    FollowOnToolComponent,
    AngularSplitModule,
    CalendarDateDisplayComponent,
    FileDownloadDirective,
    TicketAuditRendererComponent,
    TimesheetCodeChooserComponent,
    LocationChooserComponent,
    DialogHeaderComponent
  ]
})
export class SharedModule {}
